import { LangCode } from "../models";

export interface HomeInput {
  id?: number;
}
